import { useEffect } from "react";
import { styled } from "@mui/material/styles";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import typography from "assets/theme/base/typography";
import Footer from "cxfcomponents/Footer";
import brand from "assets/images/cxf_logo.png";

// Images
import error404 from "assets/images/illustrations/error-404.png";

const MaintenanceWrapper = styled(SoftBox)(() => ({
  height: "100vh",
  padding: 24,
  "& > .maintenance-container": {
    height: "calc(100% - 23px)",

    "& .logo-wrapper": {
      padding: "5px 0 0 8px"
    }
  }
}));

function Maintenance() {
  const { d4, d5 } = typography;

  useEffect(() => {});

  return (
    <MaintenanceWrapper>
      <SoftBox className="maintenance-container" p={2}>
        <SoftBox className="logo-wrapper">
          <SoftBox
            component="img"
            className="brand"
            src={brand}
            alt="CXFabric"
            width="148.8px"
            sx={{
              maxHeight: "50px",
              objectFit: "cover"
            }}
          />
        </SoftBox>

        <SoftBox height="100%">
          <SoftBox
            sx={{
              display: "flex",
              height: "100%",
              flexDirection: "column",
              justifyContent: "start",
              alignItems: "center"
            }}
          >
            <SoftBox
              sx={{
                height: "40%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <SoftBox
                // fontSize={{ xs: d5.fontSize, sm: d4.fontSize, md: d3.fontSize, lg: d1.fontSize }}
                fontSize={{ xs: d5.fontSize, sm: d4.fontSize }}
                lineHeight={1.2}
                mb={1}
              >
                <SoftTypography
                  variant="inherit"
                  color="warning"
                  textGradient
                  fontWeight="bold"
                  textAlign="center"
                >
                  CXFabric is currently down for maintenance
                </SoftTypography>
              </SoftBox>
              <SoftTypography
                variant="h2"
                color="secondary"
                textGradient
                fontWeight="bold"
                textAlign="center"
              >
                We expect to be back shortly. Thank you for your patience!
              </SoftTypography>
            </SoftBox>
            <SoftBox sx={{ height: "50%" }}>
              <SoftBox
                component="img"
                src={error404}
                alt="error-404"
                maxHeight="100%"
                maxWidth="100%"
              />
            </SoftBox>
          </SoftBox>
        </SoftBox>
      </SoftBox>
      <Footer />
    </MaintenanceWrapper>
  );
}

export default Maintenance;
